export enum Role {
  BASIC = -1,
  ADMIN = 0,
  VIEWER = 1,
  CRO = 2,
  CUSTOMER_SUCCESS = 3,
}
